/**
 * I ruoli che aprono la CREAZIONE e la SPESA sugli avatar nello Studio di staging (I-416; lotto «ruoli creatore», 11/10).
 * Un elenco, perche' QAvatar legge la stessa lista (`AVATAR_CREATOR_ROLES` su qavatar-stg) e la TMA deve dire lo stesso.
 * Dal 25/10 (chiusura di ADR-0221 §6) nessun file env la assegna: vale `administrator` su entrambi i lati.
 * Senza import: `env.ts` lo chiama, non il contrario.
 */
export const RUOLO_CREATORE_DI_BASE = 'administrator';

/**
 * `VITE_AVATAR_CREATOR_ROLES` (lista con le virgole, SOLO `.env.staging`): ritaglia gli spazi, toglie i vuoti e i doppioni.
 * ⚠️ Assente, vuota o fatta solo di virgole vale `administrator`: mai un elenco vuoto (che qui significherebbe «nessuno crea»
 * e, letto al contrario da chi lo cambia, «tutti creano»).
 */
export function leggiRuoliCreatore(grezzo: string | undefined): readonly string[] {
  const ruoli = [...new Set((grezzo ?? '').split(',').map((r) => r.trim()).filter(Boolean))];
  return ruoli.length > 0 ? ruoli : [RUOLO_CREATORE_DI_BASE];
}
